import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from "./common/Header";
import { getTestCaseAnswerKey } from '../api';

const LINE_COLUMNS = [
    ['lineNumber', 'Line'],
    ['styleName', 'Style'],
    ['colorName', 'Color'],
    ['quantity', 'Qty'],
    ['unit', 'Unit'],
    ['unitCost', 'Unit Cost'],
];

const NoteList = ({ title, notes }) => {
    if (!notes || notes.length === 0) return null;
    return (
        <p><strong>{title}:</strong> {Array.isArray(notes) ? notes.join(' | ') : String(notes)}</p>
    );
};

const useAnswerKey = (testCaseName) => {
    const [orders, setOrders] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        getTestCaseAnswerKey(testCaseName).then(setOrders).catch((err) => setError(err.message));
    }, [testCaseName]);
    return { orders, error };
};

// Shows a test case's answer key: the expected orders saved when the test case was added.
const TestCaseAnswerKey = () => {
    const { testCaseName } = useParams();
    const { orders, error } = useAnswerKey(testCaseName);

    return (
        <div>
            <Header />
            <main>
                <div className="pof2frms-container">
                    <div className="pof2frms-head">
                        <h1>Answer Key: {testCaseName}</h1>
                        <Link to="/test-cases"><button className="btn">Back to Test Cases</button></Link>
                    </div>
                    {error && <p>Could not load the answer key: {error}</p>}
                    {!error && orders === null && <p>Loading...</p>}
                    {orders && orders.length === 0 && <p>No answer key saved for this test case.</p>}
                    {orders && orders.map((order) => (
                        <div key={order.ordertype} style={{ marginBottom: 32 }}>
                            <h3>Order type: {order.ordertype}</h3>
                            <div className="po2frms-table">
                                <table>
                                    <thead>
                                        <tr>{LINE_COLUMNS.map(([key, label]) => <th key={key}>{label}</th>)}</tr>
                                    </thead>
                                    <tbody>
                                        {order.lines.map((line) => (
                                            <tr key={line.lineNumber}>
                                                {LINE_COLUMNS.map(([key]) => <td key={key}>{line[key]}</td>)}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <NoteList title="Private notes" notes={order.privateNotes} />
                            <NoteList title="Public notes" notes={order.publicNotes} />
                            <NoteList title="Work order notes" notes={order.workOrderNotes} />
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default TestCaseAnswerKey;
